import React from 'react'
import { NotificationInline } from 'oio-react'
import { Link } from 'react-router-dom'
import { adminUrl } from 'config/constants/urls'

const AdminWorkspacePageUpdatesBlock = () => (
   <NotificationInline
      borderRadius="6px"
      type="info"
      title="Important Note:"
      message={(
         <>
            {'We\'ve updated how Pages and Content Types are created, edited and managed. To learn more about these changes,'}
            &nbsp;
            <Link to={`${adminUrl}/page-updates`}>
               <u style={{ color: '#0075e0' }}>click here</u>
               .
            </Link>
         </>
      )}
      paddingHorizontal="12px"
      paddingVertical="12px"
      textSize="1.5"
   />
)

export default AdminWorkspacePageUpdatesBlock
